var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 192,
    viewBox: "0 0 192 192",
    width: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34 22v117l62 31 62-31v-117z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 69.686h-52v57.314l38 19 38-19v-39m0-12v-30h-82",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82 88v27l14 7 14-7",
    stroke: "#020000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCred);
export default __webpack_public_path__ + "static/media/cred.fa58dc70d803e960a99d75643300f5e0.svg";
export { ForwardRef as ReactComponent };